// Public community links shared by the site pages.
export const discordInviteURL = 'https://discord.gg/3A4pxSabq'
